const words = [
  "Connect Better.",
  "Collaborate Smarter.",
  "Grow Together.",
];

export default function Marquee() {
  const row = [...words, ...words, ...words, ...words];
  return (
    <section
      className="relative overflow-hidden border-y border-[#1e3a8a]/15 bg-[#1e3a8a] py-5"
      data-testid="marquee-section"
    >
      <div className="marquee-track">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center">
            {row.map((w, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span className="px-6 text-xl font-extrabold tracking-tight text-white sm:text-2xl">
                  {w}
                </span>
                <span className="h-2 w-2 rounded-full bg-[#60a5fa]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
